import { axiosInstance as axios } from "services";

export const addMaterialPersonel = async (body) => {
  const { data } = await axios.post("/supplier/addmaterialPersonel", body);
  if (!data.success) throw new Error(data.error || "Failed to add material personel");
  return data;
};

